export default __webpack_public_path__ + "static/media/bg-motorcycle-logistics-center.bac17bb8.png";